import lazier from '@shared/components/Lazier';

export const FeatureFlagsPage = lazier(() => import('./FeatureFlagsTable'));
export default FeatureFlagsPage;
